import { useCallback } from 'react';
import { useTenantCode, useTenantConfig } from 'utils/hooks/useTenantConfig';
import { useLoggedInUser } from 'src/utils/hooks/useLoggedInUser';
import { MixpanelEvent } from './MixPanelTypes';

export const useEnrichEvent = () => {
  const tenantCode = useTenantCode();
  const authUser = useLoggedInUser();
  const envType = useTenantConfig()?.tenantConfig?.environment;
  const userRole = authUser?.person?.userRole;
  const userUid = authUser?.uid ?? 'unknown';
  const personUid = authUser?.person?.personUid;

  const enrichEvent = useCallback(
    (event: MixpanelEvent): MixpanelEvent => {
      const richEvent: MixpanelEvent = {
        ...event,
        userType: userRole,
        customer: tenantCode,
        // The naming for the following property comes from Mixpanel and is something we have no control over
        // eslint-disable-next-line @typescript-eslint/naming-convention
        distinct_id: userUid,
        personUid,
        envType
      };
      return richEvent;
    },
    [envType, personUid, tenantCode, userRole, userUid]
  );
  return { enrichEvent };
};

/* Check to make sure that the Mixpanel event is enriched with identifying properties */
export const isEnriched = (richEvent: MixpanelEvent): boolean => {
  if (
    richEvent?.userType &&
    richEvent?.customer &&
    richEvent?.distinct_id &&
    richEvent?.personUid &&
    richEvent?.envType
  ) {
    return true;
  }
  return false;
};
